import usePagination from '@/hooks/usePagination';
import { ContentEntity, ResourceStatusEnum } from '@/types/schema';

import { FilterManagerReturnType } from '../../../learner/views/LearnerProfile/components/LearnerProfileEntity/types';
import { useLearningContentsInCollectionQuery } from '../../graphql/queries/generated/contentsInCollection';

interface Params {
  state?: FilterManagerReturnType['state'];
  searchString?: string;
  ids?: string[];
  collectionId: string;
  pause?: boolean;
  shareable?: boolean;
}

export default function useContentsInCollection({
  searchString,
  ids,
  collectionId,
  shareable,
  pause,
  state,
}: Params) {
  const { data, error, fetchMore, isFetching } = usePagination(
    useLearningContentsInCollectionQuery,
    {
      filters: {
        ids,
        name: searchString,
        status: [ResourceStatusEnum.Published, ResourceStatusEnum.UnpublishedChanges],
        shareable,
        sourceLanguageContent: true,
        ...state?.filter,
      },
      first: ids?.length ? ids.length : undefined,
      collectionId,
    },
    {
      requestPolicy: 'network-only',
      edgeKey: 'contents',
      pause: pause || (ids?.length === 0 && searchString === undefined),
    },
  );

  return {
    // TODO @HimanshuSahu31 refactor explicit type cast
    contents: data as ContentEntity[],
    error,
    fetchMore,
    initialFetching: isFetching,
  };
}
